<template>
<div class="main mt15 p34">
	<Card v-for="(item, index) in list" :key="index" class="mt20">
		<div class="title">批改时间：{{item.createTime}}
            <span class="ml15">批改状态：{{item.endorseStatusDesc}}</span>
		</div>
		<Table :columns="columns" border :data="item.subjectMatter"></Table>
		<slot :item="item"></slot>
	</Card>
	<Alert v-if="list.length==0" align="center">暂无批改记录</Alert>
</div>
</template>
<script>
import FileShow from '@/components/common/FileShow'
export default {
    components:{FileShow},
    props:{
        columns:{
            type:Array,
            default(){
                return []
            }
        },
    },
	data () {
		return {
			id:this.$route.params.id,
			list:[],
			type:this.$route.params.type,
			fileList:[]
		}
	},
	created () {
		this.getInfo();
	},
	methods:{
		/*获取批改记录信息*/
		getInfo () {
			// 货车雇主去掉脱敏
			let url = '';
			if(this.type=='person'){
				url = '/broker/insurance/endorse/listOfPolicy.dst'
			} else{
				url = '/broker/insurance/endorse/listOfPolicy'
			}
			this.$axios.get(url,{
				insurancePolicyId:this.id
			}).then(res=>{
				this.list=res||[];
			});
		},
	}
}
</script>
<style scoped lang="less">
.upload{
	margin-right: 20px;
	margin-top: 10px;
	display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/EditRecordContainer.vue